import actions from './actions'
import mutations from './mutations'

const state = function () {
  return {
    currentTarget: {},
    repostDates: [],
    segmentData: [],
    pidLists: [],
    currentNotification: {},
    selectedDayPartNetworks: [],
    selectedViewershipNetworks: [],
    droppedAttributes: [],
    showDeleteModal: null,
    showSelectMarketDemoModal: null,
    showAppendSegmentsModal: null,
    showDownloadPidListModal: null,
    showDroppedAttributesModal: false,
    isLoading: false,
    isDownloadingTarget: new Set(),
    isCompletedDownloadingTarget: new Set(),
    showRePostingModel: 0,
    promotedNetworks: null,
    hasChanged: false
  }
}

const getters = {
  selectedViewershipNetworks (state) {
    return state.selectedViewershipNetworks
  },
  currentTarget (state) {
    return state.currentTarget
  },
  currentTargetHasChanged (state) {
    return state.hasChanged
  },
  segmentData (state) {
    return state.segmentData
  },
  pidLists (state) {
    return state.pidLists
  },
  isLoading (state) {
    return state.isLoading
  },
  currentNotification (state) {
    return state.currentNotification
  },
  networksToShowDayParts: state => {
    return state.selectedDayPartNetworks
  },
  isDownloadingTarget: (state) => state.isDownloadingTarget,
  isCompletedDownloadingTarget: (state) => state.isCompletedDownloadingTarget
}

const module = {
  state,
  getters,
  actions,
  mutations
}

export default module



// WEBPACK FOOTER //
// ./src/app/appLogic/targets/currentTarget/store/index.js